import { SxProps, Theme } from '@mui/material';

export const surveyClosedIconSx: SxProps<Theme> = () => ({
  margin: '20px 0',
});
